// Object.freezeを使用しないと外部で値を書き換えることが出来る
// Object.freezeはネストしたオブジェクトまで見ないので、Objectの中でObjectを宣言する場合、宣言するObjectにもObject.freezeをつける
import env from '@/config/env.js'
let config = {}
if(env.prod){
    config = {
        TEST_DATA: 'test_data_prod',
        DOMAIN: 'http://192.168.11.2:4000/'
    }
}
if(env.dev){
    config = {
        TEST_DATA: 'test_data_dev',
        DOMAIN: 'http://192.168.11.2:4000/'
    }
}
export default Object.freeze(config);

